import { useAtomValue } from 'jotai';

import { mePermissionsState } from '../atom';

export const useGetMePermissions = () => {
  const permissions = useAtomValue(mePermissionsState);

  return {
    permissions,
  };
};
